import React from 'react';
import { Row, Col } from 'react-bootstrap';
import MyButton from '@components/MyButton';
import { ProjectModel } from '@models/Models';

interface Props {
    onDelete: (id: string) => void;
    onExport: (id: string) => void;
    item: ProjectModel;
    loading: boolean
}

const ArchivedProject: React.FC<Props> = ({ onDelete, onExport, item, loading }) => {
    return (
        <Row>
            <Col xs={12} lg={6}>
                <h4 className='text-black-50'>{item.name}</h4>
                <p className='text-black-50 text-info'>{new Date(item.createdAt as string).toDateString()}</p>
            </Col>
            <Col xs={12} lg={6} className='d-flex align-items-center justify-content-end'>
                <div className='d-flex flex-row align-items-center gap-3'>
                    <MyButton
                        title={loading ? "Loading..." : "Download"}
                        isSecundary={false}
                        onClick={() => onExport(item.id)}
                    />
                    <MyButton
                        title={loading ? "Loading..." : "Delete"}
                        isSecundary={false}
                        onClick={() => onDelete(item.id)}
                        backgrounColor='#8b0000'
                    />
                </div>
            </Col>
        </Row>
    )
}

export default ArchivedProject